/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/destructuring-assignment */
import React, {
  useEffect, useRef, useState, useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import Select, { components } from 'react-select';
import IcomoonReact from 'icomoon-react';
import { VariableSizeList as List } from 'react-window';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTheme } from 'emotion-theming';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import Text from '../../../../shared/_TBComponents/Text';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { getExerciseOptions, searchExerciseOptions } from '../../utils/exercisePickerOptions';
import useUserScrollIntent from '../../hooks/useUserScrollIntent';
import useVisibleMenuSpace from '../../hooks/useVisibleMenuSpace';
import {
  setActiveModal,
  addPreSavedItemToCalendarItemsArray,
  addPreSavedItemToProgramItemsArray,
  setExercisePickerSearchTerm,
  setSwapDropdownToggleEnabled,
} from '../../ducks/calendarActions';

const FOOTER_ICON_TOOLTIP_ID = 'exercise-picker-footer-icon-tooltip';
const MENU_FOOTER_HEIGHT = 45;
/** The footer plus two option rows - the least the menu shrinks to when the
 * on-screen keyboard leaves little room. */
const MIN_VISIBLE_MENU_HEIGHT = MENU_FOOTER_HEIGHT + 80;
/** Touch drags that run past the end of the results stay in the list instead
 * of scrolling the page behind it - which would push the search input under
 * the on-screen keyboard and re-render the menu back to its first result. */
const MENU_LIST_SCROLL_STYLE = { overscrollBehavior: 'contain' };

const IconContainer = styled('div')`
  height: 25px;
  width: 25px;
  border-radius: ${(props) => (props.square ? '4px' : '50%')};
  color: ${(props) => (props.color ? props.color : props.theme.colors.text)};
  border: ${(props) => (props.backgroundColor && `1px solid ${props.backgroundColor}`)};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => (props.square ? '8px' : '5px')};
  ${(props) => props.backgroundColor && `background: ${props.backgroundColor}`};
  ${(props) => props.square && 'padding: 4px'}; 
`;

const HoverText = styled('div')`
  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const FooterItemContainer = styled('div')`
  border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  height: 44px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  transition: all 250ms ease-in-out;
  ${(props) => props.addBorderTop && `border-top: 1px solid ${props.theme.colors.borderLight}`};
  ${(props) => props.addBorderTop && 'padding-top: 12px'};
`;

const FooterNameAndIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

/** Lets the truncated Add "..." label shrink. Kept off the shared wrapper,
 * where it would let "Shift+Enter" slide under the icons in narrow menus. */
const FooterAddNameWrapper = styled(FooterNameAndIconWrapper)`
  min-width: 0;
`;

const FooterIconBox = styled('div')`
  display: flex;
  color: ${({ theme }) => theme.colors.textSecondary};
  align-items: center;
  justify-content: center;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 4px;
  ${(props) => props.borderColor && `border: 1px solid ${props.borderColor}`};
  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const SelectWrapper = styled('div')`
  .select-dropdown-exercise-picker {
    .select-dropdown-exercise-picker__menu-list {
      /* Hide the default scrollbar track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      
      /* Style the scrollbar width */
      &::-webkit-scrollbar {
        width: 6px;
      }
      
      /* Style the scrollbar thumb */
      &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.scrollbarThumb};
        border-radius: 3px;
      }
      
      /* For Firefox */
      scrollbar-width: thin;
      scrollbar-color: ${({ theme }) => theme.colors.scrollbarThumb} transparent;
    }
  }
`;

const IconBox = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  background-color: ${(props) => props.backgroundColor};
  cursor: pointer;
  border-radius: 4px;
  :hover {
    opacity: 0.7;
  }
`;

const IconBoxContainer = styled('div')`
  display: flex; 
  gap: 8px;
`;

const CustomOption = ({ lastKeyPressed, addExercisePicker, ...props }) => {
  const optionRef = useRef(null);
  const dispatch = useDispatch();
  const { colors } = useTheme();
  const { isFocused } = props;

  useEffect(() => {
    if (isFocused && optionRef.current) {
      if (lastKeyPressed.current === 'ArrowUp' || lastKeyPressed.current === 'ArrowDown') {
        optionRef.current.scrollIntoView({ block: 'nearest' });
      }
    }
  }, [isFocused]);

  return (
    <components.Option {...props} innerRef={optionRef}>
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      >
        <div
          style={{ display: 'flex' }}
        >
          <IconContainer
            color={props.data.iconColor}
            square={props.data?.squareIconContainer}
            backgroundColor={props.data?.iconBackgroundColor}
          >
            <IcomoonReact
              iconSet={iconSet}
              size={16}
              icon={props.data.icon}
              color={props.data.iconColor || colors.text}
            />
          </IconContainer>
          {props.children}
        </div>
        {props.data.media?.length ? (
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon='video-camera'
            color={colors.textSecondary}
            style={{
              marginRight: 5, marginLeft: 5, minWidth: 16, cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(setActiveModal('createNewComponentModal', {
                type: props?.data?.type, editModal: true, disabledEditModal: true, itemInfoForEditModal: props?.data, isPreviewOnly: !addExercisePicker,
              }));
            }}
          />
        ) : (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {props?.data?.type && props?.data?.type !== 'rest' && props?.data?.type !== 'session_break' && props?.data?.type !== 'video' && (
            <IcomoonReact
              iconSet={iconSet}
              size={16}
              icon='info2'
              color={colors.textSecondary}
              style={{
                marginRight: 5, marginLeft: 5, minWidth: 16, cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(setActiveModal('createNewComponentModal', {
                  type: props?.data?.type, editModal: true, disabledEditModal: true, itemInfoForEditModal: props?.data, isPreviewOnly: !addExercisePicker,
                }));
              }}
            />
            )}
          </>
        )}
      </div>
    </components.Option>
  );
};

const CustomSingleValue = (props) => {
  const { colors } = useTheme();
  return (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconContainer
          square
        >
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon={props.data.icon}
            color={props.data.color || colors.text}
          />
        </IconContainer>
        {props.children}
      </div>
    </components.SingleValue>
  );
};

const SelectDropdownExercisePicker = React.memo(({
  defaultValue,
  textWrapperRef,
  iconOb,
  setIconOb,
  fullWidthInput,
  typeToFilter,
  isChecked,
  placeholder,
  addExercisePicker,
  addExerciseToggleMenuOpen,
  setAddExerciseToggleMenuOpen,
  selectedOption,
  setSelectedOption,
  showSelectOnStart,
  tabIndex,
  date,
  dayNumber,
  isWeekView,
  expandDay,
  assignedId,
  disableMenuScrollBlock,
  isDisabled,
}) => {
  const { colors } = useTheme();
  const dispatch = useDispatch();
  const selectRef = useRef(null);
  const lastKeyPressed = useRef(null);
  const virtualizedListRef = useRef({});
  const listRef = useRef({});
  const [width, setWidth] = useState(null);
  const [maxWidth, setMaxWidth] = useState(300);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const textRef = useRef(null);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const hasExerciseManagementAccess = currentUser?.userSettings?.exercises === 1;
  const swapDropdownToggleEnabled = useSelector((state) => state.calendar.data.swapDropdownToggleEnabled);
  const menuIsOpen = addExerciseToggleMenuOpen;
  const setMenuIsOpen = setAddExerciseToggleMenuOpen;
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);
  /** While the on-screen keyboard is up, iOS Safari scrolls the page and
   * renders fixed elements as if they were absolute, so a fixed menu lands a
   * keyboard-height away from its input on every re-render. Touch devices
   * position the menu against the page instead. */
  const isTouchDevice = useMemo(
    () => typeof window === 'object' && !!window.matchMedia?.('(pointer: coarse)').matches,
    [],
  );
  const visibleMenuSpace = useVisibleMenuSpace(
    menuIsOpen,
    () => selectRef.current?.select?.controlRef,
    () => virtualizedListRef.current,
  );
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  /** Use the explicit `date` prop when provided (week-view rows and the
   * month-view add-exercise row pass a specific day), otherwise fall
   * back to the calendar's selectedDate (day view + swap flow). */
  const effectiveDate = date || selectedDate;
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');

  const allExercises = useSelector((state) => state.calendar.data.allExercises);
  const tagsForAccount = useSelector((state) => state.calendar.data.tagsForAccount);
  const weekViewHorizontallyExpandedDay = useSelector(
    (state) => state.calendar.data.weekViewExpandedDay,
  );

  /** Function to update width based on size of exercise name */
  const updateWidth = () => {
    if (textRef.current) {
      setWidth(textRef?.current?.offsetWidth); /** Add padding */
    }
  };
  const updateMaxWidth = () => {
    if (textWrapperRef?.current) {
      setMaxWidth(textWrapperRef?.current?.offsetWidth);
    }
  };

  /** Width the picker last laid out at, so a resize can tell a real width
   * change from one that only touched the height. */
  const lastWindowWidthRef = useRef(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      updateWidth();
      updateMaxWidth();
      setWindowWidth(window.innerWidth);
      /** Close the dropdown only when the window gets narrower or wider
       * (rotation, resizing a desktop window). Opening an on-screen keyboard
       * also fires resize - Android Chrome fires it even when no size changes,
       * and older Android browsers shrink only the height - and blurring then
       * would close the picker the moment its search input is focused. */
      if (window.innerWidth === lastWindowWidthRef.current) return;
      lastWindowWidthRef.current = window.innerWidth;
      if (selectRef?.current) {
        selectRef?.current?.blur();
      }
    };

    /** Run updateWidth initially and add resize event listener */
    updateWidth();
    updateMaxWidth();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [selectedOption, textRef]);

  useEffect(() => {
    /** check if use has clicked swap from dropdown and open the menu */
    if (swapDropdownToggleEnabled === assignedId) {
      setMenuIsOpen(true);
      dispatch(setSwapDropdownToggleEnabled(false));
    }
  }, [swapDropdownToggleEnabled]);

  useEffect(() => {
    const handleMouseOut = (e) => {
      /** If mouse leaves the window (no related target)  we want to close the menu
       * to prevent weird remounts of the menu when mouse leaves portal
      */
      if (!e.relatedTarget && !e.toElement) {
        // setMenuIsOpen(false);
      }
    };

    window.addEventListener('mouseout', handleMouseOut);

    return () => {
      window.removeEventListener('mouseout', handleMouseOut);
    };
  }, []);

  /** we need to manually handle click outside because portaling
   * was creating an issue where clicking below the menu was not closing it
   * probably related to parent element and nested draggable/droppable containers but this fixes that issue
   */

  useEffect(() => {
    const handleClickOutside = (event) => {
      /** The transposed table's set-number superset picker portals to
       * document.body, so a click on a superset letter looks like an
       * outside click here. Ignore it so choosing a superset doesn't
       * collapse the add-exercise field. */
      if (event.target?.closest?.('.transposed-superset-popover')) return;
      if (selectRef?.current
        && selectRef?.current?.select?.controlRef
        && selectRef?.current?.select.controlRef.contains(event.target) /**  clicking control */
      ) {
        setMenuIsOpen(!menuIsOpen);
      }
      if (selectRef?.current
        && virtualizedListRef?.current
        && virtualizedListRef?.current?.contains
        && selectRef?.current?.select?.controlRef
        && !selectRef?.current?.select.controlRef.contains(event.target) /** Not clicking control */
        && !virtualizedListRef?.current?.contains(event.target) /** Not clicking menu */
      ) {
        setMenuIsOpen(false);
        setAddExerciseToggleMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuIsOpen]);

  /** Parents mount this picker only while it's open, so skip the mount run -
   * otherwise the menu would close itself the moment it opens. */
  const hasMountedRef = useRef(false);
  const isUserScroll = useUserScrollIntent();
  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    /** Close when the user scrolls the calendar - not when the browser
     * scrolls it to bring the freshly focused search input into view. */
    if (!isUserScroll()) return;
    if (selectRef?.current) {
      selectRef?.current?.blur();
      setAddExerciseToggleMenuOpen(false);
    }
  }, [calendarContainerScrollPosition]);

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const accessoryItems = useSelector((state) => state.calendar.data.calendarItemContainers.accessoryCalendarItems);

  /** The option list the search runs over. Exercise options come from the
   * shared cache (one copy per allExercises array across every picker - see
   * exercisePickerOptions.js); tags and quick-add items are small lists. */
  const optionsToSearch = useMemo(() => {
    const tagOptions = tagsForAccount.map((exercise) => ({
      ...exercise,
      name: exercise.name,
      exerciseId: exercise.id,
      icon: 'tag2',
      iconColor: '#FF4500',
      squareIconContainer: true,
      iconBackgroundColor: 'rgba(255, 69, 0, 0.2)',
    }));
    if (typeToFilter === 'T' || typeToFilter === 'tag') return tagOptions;

    const exerciseOptions = getExerciseOptions(allExercises, typeToFilter);
    /** the add exercise picker also offers tags and quick options for rest, video and session break */
    if (!addExercisePicker) return exerciseOptions;
    const accessoryItemOptions = accessoryItems.map((exercise) => ({
      ...exercise,
      name: exercise.name,
      exerciseId: exercise.id,
      squareIconContainer: true,
      iconColor: colors.textSecondary,
      iconBackgroundColor: colors.surface,
    }));
    return [...exerciseOptions, ...tagOptions, ...accessoryItemOptions];
  }, [allExercises, tagsForAccount, accessoryItems, typeToFilter, addExercisePicker, colors]);

  const [inputValue, setInputValue] = useState('');
  /** Search is handled manually - there were no select search config options
   * that handled the search the way we needed. */
  const searchedExercises = useMemo(
    () => searchExerciseOptions(optionsToSearch, inputValue),
    [optionsToSearch, inputValue],
  );

  /** we need to make sure that if the user opens the swap menu from the
   * calendar dropdown we focus on the input when it's opened
   */
  useEffect(() => {
    if (menuIsOpen && selectRef?.current) {
      selectRef?.current?.focus();
    } else {
      selectRef?.current?.blur();
      setInputValue('');
      return;
    }

    /** set focused option to default value when the menu is opened */
    const defaultOption = searchedExercises.find((option) => option.exerciseId === defaultValue?.id);
    if (selectRef.current) {
      selectRef.current.select.state.focusedOption = defaultOption;
    }
  }, [menuIsOpen]);

  const handleMenuClose = () => {
    setMenuIsOpen(false);
    setAddExerciseToggleMenuOpen(false);
    if (iconOb) {
      const newIconOb = { ...iconOb };
      newIconOb.swapDropdownToggle.enabled = false;
      setIconOb(newIconOb);
    }
    /** reset searched exercises to all */
    setInputValue('');
    /** blur input when the menu is closed */
    if (selectRef?.current?.select?.inputRef) {
      selectRef?.current?.select.inputRef.blur();
      selectRef?.current?.blur();
    }
  };

  const handleAddExercise = (option) => {
    const newItem = {
      ...option,
      type: option.type || 'T',
      icon: option.icon,
      title: option.name,
      exerciseId: parseInt(option.id, 10),
      id: `${option.id}-${generateUniqueId()}`,
      assignedId: `${option.id}-${generateUniqueId()}`,
      preSave: true,
    };
    if (programType === 'free-form-program') {
      dispatch(addPreSavedItemToProgramItemsArray(newItem, dayNumber || selectedProgramDayNumber));
    } else {
      dispatch(addPreSavedItemToCalendarItemsArray(newItem, endpointFormattedDate));
    }
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const MenuList = (props) => {
    const { children, maxHeight: placementMaxHeight } = props;
    const maxHeight = visibleMenuSpace
      ? Math.max(MIN_VISIBLE_MENU_HEIGHT, Math.min(placementMaxHeight, visibleMenuSpace))
      : placementMaxHeight;
    const rowHeights = useRef({});
    const showAddLabel = !children?.length && !!inputValue;
    const FooterNameWrapper = showAddLabel ? FooterAddNameWrapper : FooterNameAndIconWrapper;

    /** Calculate height based on the children length or a default */
    const childrenLengthBy40 = children?.length ? children.length * 40 : 0;
    const listHeight = Math.min(childrenLengthBy40, maxHeight - 45); // Subtract footer height
    const getRowHeight = (index) => rowHeights.current[index] || 40;
    const height = Math.min(childrenLengthBy40 + 45, maxHeight);

    const initialIndex = searchedExercises.findIndex((option) => option.exerciseId === defaultValue?.id);
    return (
      <div ref={virtualizedListRef} style={{ height, position: 'relative' }}>
        <List
          ref={listRef}
          height={listHeight}
          itemCount={children.length}
          itemSize={(index) => getRowHeight(index)}
          initialScrollOffset={defaultValue?.id && initialIndex * getRowHeight(initialIndex)}
          style={MENU_LIST_SCROLL_STYLE}
        >
          {({ index, style }) => {
            const rowRef = useRef({});

            useEffect(() => {
              if (rowRef.current) {
                const rowHeight = rowRef.current.getBoundingClientRect().height;
                if (rowHeights.current[index] !== rowHeight) {
                  rowHeights.current[index] = rowHeight;
                  listRef.current?.resetAfterIndex(index);
                }
              }
            }, [index]);

            return (
              <div style={style}>
                <div
                  ref={rowRef}
                  data-index={index}
                >
                  {children[index]}
                </div>
              </div>
            );
          }}
        </List>
        {/* Footer is now inside the main container, no absolute positioning */}
        <div
          style={{
            background: colors.surfaceElevated,
            paddingLeft: 8,
            paddingRight: 8,
            textAlign: 'center',
            fontSize: '16px',
            width: '100%',
            borderBottomRightRadius: 4,
            borderBottomLeftRadius: 4,
            display: 'flex',
            height: 45,
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <FooterItemContainer
            onClick={() => {
              dispatch(setActiveModal('createNewComponentModal', {
                type: !hasExerciseManagementAccess && (typeToFilter === 'L' || !typeToFilter) ? 'N' : typeToFilter,
                openedFromExercisePicker: true,
                targetDate: endpointFormattedDate,
              }));
            }}
          >
            <FooterNameWrapper>
              <FooterIconBox backgroundColor={colors.surface} borderColor={colors.borderLight}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={10}
                  icon='plus'
                  style={{ color: colors.textSecondary, fill: colors.textSecondary }}
                />
              </FooterIconBox>
              {showAddLabel ? (
                /** The footer is fixed-height, so a long search must stay on one
                 * line rather than wrap past it in narrow cells. */
                <Text
                  truncate
                  styledWrapperProps={{ minWidth: 0 }}
                  styledTextProps={{ textAlign: 'left' }}
                >
                  Add
                  {' '}
                  <span style={{ fontWeight: 700 }}>{`"${inputValue}"`}</span>
                </Text>
              ) : (
                <>
                  <HoverText>
                    {windowWidth > 390 ? (
                      <Text>Create New Exercise</Text>
                    ) : <Text>Create Exercise</Text>}
                  </HoverText>
                  <div style={{
                    color: colors.textSecondary, marginLeft: '5px', fontFamily: 'nunito sans', display: windowWidth < 500 ? 'none' : 'flex',
                  }}
                  >
                    Shift+Enter
                  </div>
                </>
              )}
            </FooterNameWrapper>
            <IconBoxContainer>
              <IconBox
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setActiveModal('createNewComponentModal', {
                    type: 'N', openedFromExercisePicker: true, targetDate: endpointFormattedDate,
                  }));
                }}
                backgroundColor='rgba(249, 191, 59, 0.2)'
                data-tooltip-id={FOOTER_ICON_TOOLTIP_ID}
                data-tooltip-content='Create New Note'
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon='note'
                  color='#F9BF3B'
                />
              </IconBox>
              <IconBox
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setActiveModal('createNewComponentModal', {
                    type: 'W', openedFromExercisePicker: true, targetDate: endpointFormattedDate,
                  }));
                }}
                backgroundColor='rgba(231, 76, 60, 0.2)'
                data-tooltip-id={FOOTER_ICON_TOOLTIP_ID}
                data-tooltip-content='Create New Warmup'
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon='warmup'
                  color='#E74C3C'
                />
              </IconBox>
            </IconBoxContainer>
          </FooterItemContainer>
          {/** Inside the menu so the anchors resolve within react-select's
            * body portal; fixed so the menu's overflow doesn't clip it. */}
          <ReactTooltip
            id={FOOTER_ICON_TOOLTIP_ID}
            place='top'
            positionStrategy='fixed'
            style={{
              backgroundColor: 'rgba(68, 68, 68, 1)',
              color: colors.white,
              fontFamily: 'Nunito Sans',
              fontSize: '13px',
              zIndex: 9999,
            }}
          />
        </div>
      </div>
    );
  };

  const MemoizedMenuList = React.memo(MenuList);

  const selectStyles = useMemo(() => (
    {
      menuPortal: (base) => {
        /** Clamp left so the menu can't overflow the right edge on narrow
         * day cells (month view). */
        const menuWidth = disableMenuScrollBlock ? 360 : 230;
        const maxLeft = typeof window !== 'undefined'
          ? window.innerWidth - menuWidth - 8
          : base.left;
        return {
          ...base,
          zIndex: 99999,
          left: Math.min(base.left, Math.max(8, maxLeft)),
        };
      },
      container: (provided) => ({
        ...provided,
        marginRight: 5,
      }),
      control: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        // width: (fullWidthInput && state.isFocused) || (addExercisePicker) || !selectedOption ? '100%' : `${width}px`,
        // maxWidth: (fullWidthInput && state.isFocused) || (addExercisePicker) || !selectedOption ? '100%' : `${maxWidth - 10}px`,
        width: (fullWidthInput && state.isFocused) || (addExercisePicker) ? '100%' : `${width}px`,
        maxWidth: (fullWidthInput && state.isFocused) || (addExercisePicker) ? '100%' : `${maxWidth - 10}px`,
        border: 'none',
        background: fullWidthInput && state.isFocused && !isChecked && !addExercisePicker ? colors.surfaceSecondary : 'transparent',
        boxShadow: 'none',
        height: 24,
        minHeight: 24,
        fontFamily: 'Nunito Sans, sans-serif',
      }),
      menu: (provided, state) => ({
        ...provided,
        width: (fullWidthInput && state.isFocused) || (addExercisePicker) ? '100%' : `${maxWidth}px`,
        maxWidth: addExercisePicker && '600px',
        /* In month-view (disableMenuScrollBlock is the signal), the
         * picker control is constrained to a narrow day cell so the
         * default `width: 100%` collapses the menu. Bump minWidth so
         * the menu matches day view's feel. */
        minWidth: disableMenuScrollBlock ? 360 : 230,
        boxShadow: '0px 4px 8px 0px #3031331A',
        left: windowWidth < 400 && '-50px',
        backgroundColor: colors.surfaceElevated,
        color: colors.text,
      }),
      menuList: (provided, state) => ({
        ...provided,
        width: (fullWidthInput && state.isFocused) || (addExercisePicker) ? '100%' : `${maxWidth}px`,
        maxWidth: addExercisePicker && '600px',
        minWidth: disableMenuScrollBlock ? 360 : 230,
        padding: 0,
        left: windowWidth < 400 && '-50px',
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        height: '24px',
        alignItems: 'center',
        fontFamily: 'Nunito Sans, sans-serif',
      }),
      input: (provided) => ({
        ...provided,
        height: '24px',
        padding: '0',
        margin: '0',
        fontSize: '16px',
        fontFamily: 'Nunito Sans, sans-serif',
        cursor: 'pointer',
        // react-select's own ink is a fixed dark grey; read the theme so the
        // typed name stays legible in dark.
        color: colors.text,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: colors.textSecondary,
      }),
      singleValue: (provided) => ({
        ...provided,
        color: colors.text,
        marginLeft: 0,
        marginRight: 0,
        fontSize: '16px',
        padding: '0',
        lineHeight: '24px',
        fontFamily: 'Nunito Sans, sans-serif',
        maxWidth: '100%',
        width: '100%',
      }),
      option: (provided, state) => ({
        ...provided,
        borderRadius: '4px',
        color: colors.text,
        fontFamily: 'Nunito Sans',
        backgroundColor: state.isFocused ? colors.surfaceSecondary : colors.surfaceElevated,
        fontSize: '16px',
        fontWeight: 400,
      }),
      indicatorsContainer: () => ({
        display: (addExercisePicker || menuIsOpen) && 'none',
      }),
      clearIndicator: () => ({
        display: 'none',
      }),
      dropdownIndicator: () => ({
        display: 'none',
        color: 'rgba(189, 189, 189, 1)',
        svg: {
          width: '16px',
          height: '16px',
        },
      }),
      indicatorSeparator: () => ({
        display: 'none',
      }),
    }
  ), [menuIsOpen, fullWidthInput, selectedOption, maxWidth, windowWidth, weekViewHorizontallyExpandedDay, width, colors]);

  return (
    <div
      onClick={(e) => {
        stopPropagation(e);
      }}
      style={{ width: addExercisePicker || fullWidthInput ? '100%' : width }}
      // style={{ width: ((fullWidthInput && menuIsOpen) || (addExercisePicker)) && '100%' }}
    >
      {/* Hidden span to measure text width */}
      <span ref={textRef} style={{ position: 'absolute', visibility: 'hidden', whiteSpace: 'nowrap' }}>
        {selectedOption?.name || defaultValue?.name}
      </span>
      {(menuIsOpen || (!addExercisePicker && showSelectOnStart)) && (
      <SelectWrapper>
        <Select
          /** react-select's scroll lock only lets touch drags through on the
           * menu list it knows about, and the custom virtualized MenuList
           * never registers one - so on touch devices it would block every
           * drag on the results. */
          menuShouldBlockScroll={!disableMenuScrollBlock && !isTouchDevice}
          /** On touch devices the on-screen keyboard rises from the bottom
           * once the search input is focused, so a menu that opened below the
           * input ends up hidden behind it. Prefer above there; react-select
           * still falls back to below when there's no room above. */
          menuPlacement={isTouchDevice ? 'top' : 'auto'}
          minMenuHeight={disableMenuScrollBlock ? 220 : 140}
          className='select-dropdown-exercise-picker'
          classNamePrefix='select-dropdown-exercise-picker'
          tabIndex={tabIndex}
          onKeyDown={(e) => {
            lastKeyPressed.current = e.key;
            const selectInstance = selectRef?.current?.select;
            const focusedOption = selectInstance?.state?.focusedOption;
            const options = selectInstance?.props?.options || [];

            const firstOptionId = options[0]?.exerciseId;
            const lastOptionId = options[options.length - 1]?.exerciseId;
            const focusedId = focusedOption?.exerciseId;

            /** Create New Exercise on Enter when no results */
            if (
              e.key === 'Enter'
              && options.length === 0 // no search results
              && inputValue?.trim()?.length > 0 // user typed something
            ) {
              e.preventDefault();
              dispatch(
                setActiveModal('createNewComponentModal', {
                  type: !hasExerciseManagementAccess && (typeToFilter === 'L' || !typeToFilter) ? 'N' : typeToFilter,
                  openedFromExercisePicker: true,
                  targetDate: endpointFormattedDate,
                }),
              );
              return; /** stop further handling */
            }

            /** Prevent ArrowUp if we're on the first item */
            if (e.key === 'ArrowUp' && (focusedId === firstOptionId || !focusedId)) {
              e.preventDefault();
              return;
            }

            /** Prevent ArrowDown if we're on the last item */
            if (e.key === 'ArrowDown' && focusedId === lastOptionId) {
              e.preventDefault();
              return;
            }

            if (e.shiftKey && e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              dispatch(setActiveModal('createNewComponentModal', {
                type: typeToFilter, openedFromExercisePicker: true, targetDate: endpointFormattedDate,
              }));
            }
          }}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          isSearchable
          filterOption={null}
          id={generateUniqueId().toString()}
          ref={selectRef}
          closeMenuOnScroll={!disableMenuScrollBlock}
          isClearable
          components={{
            // eslint-disable-next-line react/no-unstable-nested-components
            Option: (props) => <CustomOption {...props} defaultValue={defaultValue} menuIsOpen={menuIsOpen} lastKeyPressed={lastKeyPressed} addExercisePicker={addExercisePicker} />,
            MenuList: MemoizedMenuList,
          }}
          options={searchedExercises}
          value={
            addExercisePicker
              ? null
              : selectedOption
                ? searchedExercises?.find((option) => option?.id === selectedOption?.id)
                : defaultValue
          }
          onChange={(option) => {
            if (!addExercisePicker) {
              setSelectedOption(option);
              updateWidth(); /** Update width when option changes */
            } else {
              setSelectedOption(null);
              handleAddExercise(option);
              /** Expand the day when an exercise is selected in week view */
              if (isWeekView && expandDay) {
                expandDay();
              }
            }
          }}
          onInputChange={(value, { action }) => {
            if (action === 'input-change') {
              setInputValue(value);
              dispatch(setExercisePickerSearchTerm(value));
            }
          }}
          defaultValue={defaultValue || null}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          /** react-select's own disable: takes the input out of the tab order
           * and refuses to open the menu. Set when the calendar item is
           * mid-save, where the row overlay stops the mouse but not the
           * keyboard. Was hardcoded false. */
          isDisabled={isDisabled}
          blurInputOnSelect
          closeMenuOnSelect
          onMenuClose={handleMenuClose}
          menuPortalTarget={document.body}
          menuPosition={isTouchDevice ? 'absolute' : 'fixed'}
          placeholder={placeholder}
          /** components can be custom styled using the styles api
           * defined in the react-select docs:
           * https://react-select.com/components#replacing-components
          */
          styles={selectStyles}
        />
      </SelectWrapper>
      )}
    </div>
  );
});

SelectDropdownExercisePicker.propTypes = {
  /** component to pass if you would like to use a
   * virtualized/windowed list
   * this is helpful for performace issues with a large list */
  defaultValue: PropTypes.instanceOf(Object),
  textWrapperRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  iconOb: PropTypes.instanceOf(Object),
  selectedOption: PropTypes.instanceOf(Object).isRequired,
  setSelectedOption: PropTypes.func.isRequired,
  setIconOb: PropTypes.func,
  fullWidthInput: PropTypes.bool,
  typeToFilter: PropTypes.string,
  isChecked: PropTypes.bool,
  placeholder: PropTypes.string,
  addExercisePicker: PropTypes.bool,
  addExerciseToggleMenuOpen: PropTypes.bool,
  setAddExerciseToggleMenuOpen: PropTypes.func,
  showSelectOnStart: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isWeekView: PropTypes.bool,
  expandDay: PropTypes.func,
  disableMenuScrollBlock: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

SelectDropdownExercisePicker.defaultProps = {
  defaultValue: undefined,
  iconOb: null,
  setIconOb: () => {},
  textWrapperRef: null,
  fullWidthInput: false,
  typeToFilter: null,
  isChecked: false,
  placeholder: '',
  addExercisePicker: false,
  addExerciseToggleMenuOpen: false,
  setAddExerciseToggleMenuOpen: () => {},
  showSelectOnStart: true,
  date: null,
  isWeekView: false,
  expandDay: () => {},
  disableMenuScrollBlock: false,
  isDisabled: false,
};

CustomOption.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  props: PropTypes.instanceOf(Object).isRequired,
};

CustomSingleValue.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  props: PropTypes.instanceOf(Object).isRequired,
};

export default SelectDropdownExercisePicker;
